import React, { useCallback } from 'react';
import {
  FormControl,
  FormHelperText,
  Icon,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import styles from './CreateParentProfile.module.css';
import { CreateParentProfileElement } from '../CreateParentProfileElement';

export const DesktopView = (): JSX.Element => {
  const createParentProfileElement = CreateParentProfileElement();
  return (
    <React.Fragment>
      <div className={styles.desktopCreateParentProfile}>
        <div className={styles.craeteParentProfileMainSecDiv}>
          <img
            className={styles.desktopHeaderIcon}
            id="desktop-header"
            alt=""
            src="assets/common/bba-logo.svg"
          />
          <div className={styles.progressIndicatorDiv}>
            <img
              className={styles.progressIndicator2Icon}
              id="progress-indicator-2"
              alt=""
              src="assets/common/progress-indicator-2.svg"
            />
          </div>
          <div className={styles.craeteParentProfileMainGroDiv}>
            <div className={styles.craeteParentProfileTitleDiv}>
              Create Parent Profile
            </div>

            <div className={styles.craeteParentProfileMainGroDiv1}>
              {createParentProfileElement.firstNameInput}
              {createParentProfileElement.lastNameInput}
              <div className={styles.craeteParentProfileMainGroDiv2}>
                <div className={styles.craeteParentProfileMainGroDiv3}>
                  {createParentProfileElement.phoneNumberInput}
                </div>
                <div className={styles.craeteParentProfileMainGroDiv4}>
                  Big Bang Academy uses the phone number to assist you for any
                  questions you may have.
                </div>
              </div>
              {createParentProfileElement.passwordInput}
              <div
                className={styles.craeteParentProfileMainGroDiv5}
                id="craete-parent-profile-main-group-tos-group"
              >
                <span
                  className={styles.craeteParentProfileMainGroSpan1}
                  id="craete-parent-profile-main-group-tos-group-prefix"
                >
                  {`By creating account, I agree to Big Bang Lab’s `}
                  {/* <a onClick={createParentProfileElement.ppButtonClickHandler}>
                    Privacy Policy
                  </a>
                  {` and `} */}
                  <a onClick={createParentProfileElement.tncButtonClickHandler}>
                    Terms & Conditions
                  </a>
                </span>
              </div>
            </div>
            <div className={styles.buttons}>
              <div
                className={styles.craeteParentProfileMainGroButton1}
                id="craete-parent-profile-main-group-next-button"
              >
                {createParentProfileElement.continueButton}
              </div>
              <div className={styles.craeteParentProfileMainGroButton}>
                {createParentProfileElement.backButton}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.desktopRightSideSectionDiv}>
          <img
            className={styles.desktopBgIcon}
            id="desktop-bg"
            alt=""
            src="assets/common/desktop-bg@3x.png"
          />
          <img
            className={styles.craeteParentProfileImageIcon}
            id="craete-parent-profile-image"
            alt=""
            src="assets/createParentProfile/craete-parent-profile-image@3x.png"
          />
        </div>
        {createParentProfileElement.tncDialog}
      </div>
    </React.Fragment>
  );
};
